import { createApp } from 'vue';
import MainMenu from './MainMenu.vue'
import SubMenu from './SubMenu.vue'
import store from './store/index';

// store.dispatch('baseMenu');

const promise = store.dispatch('loadMenuItems');
promise.then(function () {
	const mainMenu = createApp(MainMenu);
	const subMenu = createApp(SubMenu);
	mainMenu.use(store);
	mainMenu.mount('#top-nav');
	subMenu.use(store);
	subMenu.mount('#navi-sub');
});





